import { useState } from 'react';
import {
  Activity,
  Circle,
  Timer,
  Zap,
} from 'lucide-react';
import { Text } from '@/components/ui/index.js';
import styles from './SportBadge.module.css';

// Map sport names to icons
const sportIcons = {
  basketball: Activity,
  running: Timer,
  tennis: Circle,
  soccer: Activity,
  swimming: Zap,
  default: Activity,
};

// Map skill levels to colors
const skillLevelColors = {
  beginner: 'var(--color-secondary-500)',
  intermediate: 'var(--color-primary-500)',
  advanced: 'var(--color-warning)',
};

/**
 * SportBadge - Sport pill with skill level indicator
 * 
 * Features:
 * - Sport name with icon
 * - Color-coded skill level indicator
 * - Hover glow effect
 * - Click to view details (placeholder)
 */
export function SportBadge({ name, skillLevel, icon, delay = 0 }) {
  const [isPressed, setIsPressed] = useState(false);

  const Icon = sportIcons[icon] || sportIcons.default;
  const skillColor = skillLevelColors[skillLevel] || skillLevelColors.beginner;

  const handleClick = () => {
    // Placeholder for viewing sport details
    console.log('View sport details:', name);
  };

  return (
    <button
      className={`${styles.badge} ${isPressed ? styles.pressed : ''}`}
      style={{ animationDelay: `${delay}ms` }}
      onClick={handleClick}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onMouseLeave={() => setIsPressed(false)}
      onTouchStart={() => setIsPressed(true)}
      onTouchEnd={() => setIsPressed(false)}
    >
      <Icon size={16} className={styles.icon} />
      <Text size="sm" weight="medium" color="primary" className={styles.name}>
        {name}
      </Text>
      <span
        className={styles.skillIndicator}
        style={{ backgroundColor: skillColor }}
        title={`Skill: ${skillLevel}`}
      />
    </button>
  );
}

export default SportBadge;
